import React from "react";
import { Link } from "react-router-dom";
import "../styles/home.css";
import "../styles/legal-layout.css";

function LegalLayout({ title, children }) {
  return (
    <div className="lsg-home">
      <nav className="lsg-nav">
        <div className="lsg-container lsg-nav-inner">
          <Link to="/" className="legal-nav-logo" aria-label="Lucky Spin Games home">
            <img
              src={`${process.env.PUBLIC_URL}/lsg/brand/lsg-horizontal-dark.svg`}
              alt="Lucky Spin Games"
            />
          </Link>

          <ul className="lsg-nav-links">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/privacy-policy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/terms">Terms</Link>
            </li>
          </ul>
        </div>
      </nav>

      <main className="legal-shell">
        <div className="lsg-container">
          <section className="legal-hero reveal visible">
            <p className="legal-eyebrow">Lucky Spin Games</p>
            <h1>{title}</h1>
          </section>

          <section className="legal-card reveal visible">{children}</section>
        </div>
      </main>

      <footer className="lsg-footer">
        <div className="lsg-container">
          <p className="lsg-footer-logo">Lucky Spin Games</p>
          <ul className="lsg-footer-links">
            <li>
              <Link to="/privacy-policy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/terms">Terms & Conditions</Link>
            </li>
            <li>
              <a href="mailto:support@luckyspingames.com">Contact Us</a>
            </li>
          </ul>
          <p className="lsg-footer-copy">
            © {new Date().getFullYear()} Lucky Spin Games Inc. All rights
            reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}

export default LegalLayout;
